import { createI18n } from 'vue-i18n'
import zhTW from './locales/zh-TW.json'
import zhCN from './locales/zh-CN.json'
import enUS from './locales/en-US.json'
import jaJP from './locales/ja-JP.json'
import whitepaperZhTW from '../locales/zh-TW/whitepaper.json'
import whitepaperZhCN from '../locales/zh-CN/whitepaper.json'
import whitepaperEnUS from '../locales/en-US/whitepaper.json'
import whitepaperJaJP from '../locales/ja-JP/whitepaper.json'

// 檢測瀏覽器語言
function detectLocale() {
  const saved = localStorage.getItem('locale')
  if (saved) return saved
  
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang.startsWith('zh')) {
    // 簡體中文：zh-CN, zh-Hans, zh-SG 等
    if (browserLang.includes('CN') || browserLang.includes('Hans') || browserLang.includes('SG')) {
      return 'zh-CN'
    }
    // 繁體中文：zh-TW, zh-Hant, zh-HK 等
    return 'zh-TW'
  }
  
  // 默認返回英文
  return 'en-US'
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en-US',
  messages: {
    'zh-TW': { ...zhTW, whitepaper: whitepaperZhTW },
    'zh-CN': { ...zhCN, whitepaper: whitepaperZhCN },
    'en-US': { ...enUS, whitepaper: whitepaperEnUS },
    'ja-JP': { ...jaJP, whitepaper: whitepaperJaJP }
  }
})

export default i18n

